export const SET_USER_INFO = "SET_USER_INFO";

export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

export const UPDATE_USER_TU_INFO = "UPDATE_USER_TU_INFO";

export const SET_OTP_UID = "SET_OTP_UID";
